<template>
  <div class="col-12">
    <transition
      tag="div"
      name="slide"
    >
      <button
        type="button"
        class="form-control bg-gray-300 border-0 py-0 d-flex w-100"
        style="min-height:78px; border-radius: 45px;"
        @click.once="next"
      >
        <div class="d-flex flex-row my-auto w-100 px-2">
          <div class="d-flex flex-column justify-content-center">
            <div class="d-flex text-start fw-bold">
              {{ company.name }} - {{ company.siret }}
            </div>
          </div>
          <div class="d-flex ms-auto">
            <span class="me-2 mt-1 text-end fw-bold">Se connecter</span>
            <font-awesome-icon
              class="d-flex m-auto p-1 cursor-pointer"
              icon="chevron-right"
              style="width:32px; height: 32px"
            />
          </div>
        </div>
      </button>
    </transition>
  </div>
</template>
<script>
import { ui, routing } from '@/mixins';

export default {
  mixins: [ui, routing],
  props: {
    company: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  methods: {
    async next() {
      await this.$store.dispatch('client/switchAccount', this.company.accountId);
      await this.$router.replace('/client').catch(() => {});
      this.$router.go(0);
      this.ui_showModal(false);
    },
  },
};
</script>
